import type { IIframelessWidgetInterface } from '~modules/IframelessElements/IframelessWidget';

/**
 * Base communication listener class to extend
 */
export abstract class IframelessWidgetListener {
  protected widgetObject: IIframelessWidgetInterface | IIframelessWidgetInterface[];

  constructor(widgetObject: IIframelessWidgetInterface | IIframelessWidgetInterface[]) {
    this.widgetObject = widgetObject;
  }

  /**
   * Widget messages listener
   * NOTE: We need to use arrow function here to bind function to this object instead of the event.
   * @param {any} event - message event
   */
  protected abstract listener: (event: any) => void;

  /**
   * 🔧 Simple util to verify event
   * @param {any} event - Message event to verify
   * @returns {boolean}
   */
  protected isValidEvent(event: any): boolean {
    // Ensure the event structure is correct
    if (!(event instanceof Object) && !(event.data instanceof Object) && !event.data.sourceWindowName) {
      return false;
    }

    // Ensure that widget name matches with the widget name of the message listener
    let matchesWidget: boolean = false;
    if (!Array.isArray(this.widgetObject)) {
      matchesWidget = event.data.sourceWindowName === this.widgetObject.id;
    } else {
      for (let widgetInterface of this.widgetObject) {
        if (widgetInterface.id === event.data.sourceWindowName) {
          matchesWidget = true;
        }
      }
    }
    return matchesWidget;
  }

  /**
   * Post message to the widget
   * @param data
   */
  public postMessage(data: any): void {
    if (Array.isArray(this.widgetObject)) {
      this.widgetObject.forEach((element) => {
        element.onLoad((widgetDiv) => widgetDiv.dispatchEvent(new MessageEvent('message', { data })));
      });
    } else {
      this.widgetObject.onLoad((widgetDiv) => widgetDiv.dispatchEvent(new MessageEvent('message', { data })));
    }
  }

  /**
   * Remove attached communication listener
   */
  public removeMessageListener() {
    window.removeEventListener('message', this.listener);
  }
}
